<template>
  <div>
    <el-select
      class="provider-selector"
      v-model="providerIds"
      filterable
      :placeholder="isSelectedAllProviders ? 'เลือกผู้ให้บริการทั้งหมดแล้ว' : 'เลือกผู้ให้บริการ'"
      clearable
      multiple
      :disabled="isSelectedAllProviders"
    >
      <el-option
        v-for="item in providerOptions"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
        <div class="provider-option">
          <img class="icon" :src="item.logoUrl" />
          <div class="name">{{ item.name }}</div>
        </div>
      </el-option>
    </el-select>
    <el-checkbox
      class="mt-2"
      v-model="isSelectedAllProviders">
      เลือกทั้งหมด
    </el-checkbox>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";

export default {
  props: ["value"],
  data() {
    return {
      providers: [],
      providerIds: [],
      isSelectedAllProviders: false
    };
  },
  computed: {
    providerOptions() {
      return this.providers.map((provider) => {
        return {
          ...provider,
          name: provider.nameOnSap
            ? `${provider.name} - ${provider.nameOnSap}`
            : provider.name
        }
      });
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupDefaultValues();
      this.setupProviders();
    },
    setupDefaultValues() {
      const {
        manageProviderIds = [],
        canManageAllProviders = false
      } = this.value;

      this.providerIds = manageProviderIds;
      this.isSelectedAllProviders = canManageAllProviders;
    },
    async setupProviders() {
      const providers = await this.fetchProviders();

      this.providers = providers.map(provider => {
        const {
          id,
          name,
          icon_url: logoUrl = "https//placehold.it/64",
          name_on_sap: nameOnSap
        } = provider;

        return {
          id,
          name,
          logoUrl,
          nameOnSap
        };
      });
    },
    async fetchProviders() {
      const response = await baanRueJaiClient.admin.subscriptions.providers.list();

      return response.data.result;
    }
  },
  watch: {
    providerIds(value) {
      this.$emit("providerIds", value);
    },
    isSelectedAllProviders(value) {
      if (value) this.providerIds = [];

      this.$emit("isSelectedAllProviders", value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.provider-selector {
  width: 100%;
}

.provider-selector:hover {
  width: 100%;
  display: block;
  font-size: 14px;
}

.provider-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/MultipleProviderSelector.vue